import { useLocation, useNavigate } from "react-router-dom";
import "../assets/Css/Dashboard.css";
import { GrFormNext } from "react-icons/gr";

export default function Breadcrumb() {
  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();

  return (
    <div className="breadcrumb">
      <span className="only-color clickable" onClick={() => navigate("/dashboard")}>
        Dashboard
      </span>
      <span className="breadcrumb-separator">
        <GrFormNext />
      </span>

      {path.includes("/usermanagement") && !path.includes("/ActionView") ? (
        <span className="breadcrumb-active">All User</span>
      ) : path.includes("/ActionView") ? (
        <>
          <span
            className="only-color clickable"
            onClick={() => navigate(-1)}
          >
            User Table View
          </span>
          <span className="breadcrumb-separator">
            <GrFormNext />
          </span>
          <span className="breadcrumb-active">User View</span>
        </>
      ) : path.includes("/ProductDetails") ? (
        <>
          <span
            className="only-color clickable"
            onClick={() => navigate(-1)}
          >
            Product Table View
          </span>
          <span className="breadcrumb-separator">
            <GrFormNext />
          </span>
          <span className="breadcrumb-active">Product View</span>
        </>
      ) : null}
    </div>
  );
}
